webpackJsonp([35783957827783],{

/***/ "./node_modules/bootstrap/dist/css/bootstrap.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/react-gtm-module/dist/Snippets.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _warn = __webpack_require__("./node_modules/react-gtm-module/dist/utils/warn.js");
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://developers.google.com/tag-manager/quickstart
	
	var Snippets = {
	  tags: function tags(_ref) {
	    var id = _ref.id,
	        events = _ref.events,
	        dataLayer = _ref.dataLayer,
	        dataLayerName = _ref.dataLayerName,
	        preview = _ref.preview,
	        auth = _ref.auth;
	
	    var gtm_auth = '&gtm_auth=' + auth;
	    var gtm_preview = '&gtm_preview=' + preview;
	
	    if (!id) (0, _warn2.default)('GTM Id is required');
	
	    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
	
	    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';
	
	    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
	
	    return {
	      iframe: iframe,
	      script: script,
	      dataLayerVar: dataLayerVar
	    };
	  },
	  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
	    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
	  }
	};
	
	module.exports = Snippets;

/***/ }),

/***/ "./node_modules/react-gtm-module/dist/TagManager.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Snippets = __webpack_require__("./node_modules/react-gtm-module/dist/Snippets.js");
	
	var _Snippets2 = _interopRequireDefault(_Snippets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagManager = {
	  dataScript: function dataScript(dataLayer) {
	    var script = document.createElement('script');
	    script.innerHTML = dataLayer;
	    return script;
	  },
	  gtm: function gtm(args) {
	    var snippets = _Snippets2.default.tags(args);
	
	    var noScript = function noScript() {
	      var noscript = document.createElement('noscript');
	      noscript.innerHTML = snippets.iframe;
	      return noscript;
	    };
	
	    var script = function script() {
	      var script = document.createElement('script');
	      script.innerHTML = snippets.script;
	      return script;
	    };
	
	    var dataScript = this.dataScript(snippets.dataLayerVar);
	
	    return {
	      noScript: noScript,
	      script: script,
	      dataScript: dataScript
	    };
	  },
	  initialize: function initialize(_ref) {
	    var gtmId = _ref.gtmId,
	        _ref$events = _ref.events,
	        events = _ref$events === undefined ? {} : _ref$events,
	        dataLayer = _ref.dataLayer,
	        _ref$dataLayerName = _ref.dataLayerName,
	        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
	        _ref$auth = _ref.auth,
	        auth = _ref$auth === undefined ? '' : _ref$auth,
	        _ref$preview = _ref.preview,
	        preview = _ref$preview === undefined ? '' : _ref$preview;
	
	    var gtm = this.gtm({
	      id: gtmId,
	      events: events,
	      dataLayer: dataLayer || undefined,
	      dataLayerName: dataLayerName,
	      auth: auth,
	      preview: preview
	    });
	    if (dataLayer) document.head.appendChild(gtm.dataScript);
	    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
	    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
	  },
	  dataLayer: function dataLayer(_ref2) {
	    var _dataLayer = _ref2.dataLayer,
	        _ref2$dataLayerName = _ref2.dataLayerName,
	        dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;
	
	    if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
	    var snippets = _Snippets2.default.dataLayer(_dataLayer, dataLayerName);
	    var dataScript = this.dataScript(snippets);
	    document.head.insertBefore(dataScript, document.head.childNodes[0]);
	  }
	};
	
	module.exports = TagManager;

/***/ }),

/***/ "./node_modules/react-gtm-module/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _TagManager = __webpack_require__("./node_modules/react-gtm-module/dist/TagManager.js");
	
	var _TagManager2 = _interopRequireDefault(_TagManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _TagManager2.default;

/***/ }),

/***/ "./node_modules/react-gtm-module/dist/utils/warn.js":
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var warn = function warn(s) {
	  console.warn('[react-gtm]', s);
	};
	
	exports.default = warn;

/***/ }),

/***/ "./src/components/NewsLetter.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _main, _input, _icon;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _data = __webpack_require__("./contentfuldata/data.json");
	
	var _data2 = _interopRequireDefault(_data);
	
	__webpack_require__("./node_modules/whatwg-fetch/fetch.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsLetter = function (_Component) {
	  _inherits(NewsLetter, _Component);
	
	  function NewsLetter(props, context) {
	    _classCallCheck(this, NewsLetter);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      email: "",
	      formSent: { error: "", success: "" },
	      newsletterSent: false
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.orderNewsletter = _this.orderNewsletter.bind(_this);
	    return _this;
	  }
	
	  NewsLetter.prototype.orderNewsletter = function orderNewsletter(e) {
	    var _this2 = this;
	
	    var formUrl = "https://cx5j4s9rc2.execute-api.eu-west-1.amazonaws.com/prod/SaveEmailToS3";
	    var brand = getLang();
	    var successText = _data2.default.singleData[brand].singleData.formSentText;
	    this.setState({
	      newsletterSent: true
	    });
	    if (this.state.email.length > 3) {
	      fetch(formUrl, {
	        method: 'POST',
	        mode: 'no-cors',
	        headers: { 'Access-Control-Allow-Origin': '*' },
	        body: JSON.stringify({ email: this.state.email })
	      }).then(function (response) {
	        return response;
	      }).then(function (json) {
	        _this2.setState({
	          formSent: { success: successText },
	          email: ""
	        });
	      }).catch(function (ex) {
	        _this2.setState({
	          email: ""
	        });
	      });
	    }
	  };
	
	  NewsLetter.prototype.handleChange = function handleChange(event) {
	    var target = event.target;
	    this.setState({
	      email: target.value
	    });
	  };
	
	  NewsLetter.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: styles.main },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6', style: styles.text },
	        _react2.default.createElement(
	          'p',
	          null,
	          this.props.text
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        !this.state.newsletterSent && _react2.default.createElement(
	          'div',
	          { className: 'input-group' },
	          _react2.default.createElement('input', { style: styles.input, className: 'form-control', placeholder: 'E-mail', value: this.state.email, onChange: this.handleChange }),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'input-group-addon', onClick: this.orderNewsletter },
	            _react2.default.createElement('i', { className: 'glyphicon glyphicon-chevron-right', style: styles.icon })
	          )
	        ),
	        this.state.formSent.success !== "" && _react2.default.createElement(
	          'div',
	          { style: styles.formsent, className: 'col-xs-12' },
	          this.state.formSent.success
	        )
	      ),
	      _react2.default.createElement('div', { className: 'clearfix' })
	    );
	  };
	
	  return NewsLetter;
	}(_react.Component);
	
	var styles = {
	  main: (_main = {
	    backgroundColor: _colors2.default.darkBlue,
	    padding: 30,
	    borderRadius: _breakpoints2.default.borderRadius
	  }, _main[_breakpoints2.default.media.siteUnderMaxWidth] = {
	    paddingTop: 15,
	    paddingLeft: 15,
	    paddingRight: 15,
	    paddingBottom: 30
	  }, _main),
	  input: (_input = {
	    padding: 30
	  }, _input[_breakpoints2.default.media.siteUnderMaxWidth] = {
	    padding: 10
	  }, _input),
	  icon: (_icon = {
	    padding: 17
	  }, _icon[_breakpoints2.default.media.siteUnderMaxWidth] = {
	    padding: 0,
	    fontSize: 12
	  }, _icon),
	  text: {
	    color: '#ffffff'
	  },
	  formsent: {
	    marginTop: 10,
	    padding: 18,
	    backgroundColor: "#218838",
	    color: "#ffffff",
	    textAlign: 'center',
	    textTransform: 'uppercase',
	    borderRadius: _breakpoints2.default.borderRadius
	  }
	};
	
	exports.default = (0, _radium2.default)(NewsLetter);
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/codebuild/output/src580589704/src/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/codebuild/output/src580589704/src/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/codebuild/output/src580589704/src/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/codebuild/output/src580589704/src/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/codebuild/output/src580589704/src/node_modules/babel-preset-stage-0/lib/index.js\",\"/codebuild/output/src580589704/src/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IndexPage = undefined;
	
	var _dividerSingleItem, _responsiveDivider, _styles;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("./node_modules/bootstrap/dist/css/bootstrap.css");
	
	var _Heroimage = __webpack_require__("./src/components/Heroimage.js");
	
	var _Heroimage2 = _interopRequireDefault(_Heroimage);
	
	var _Blueitems = __webpack_require__("./src/components/Blueitems.js");
	
	var _Blueitems2 = _interopRequireDefault(_Blueitems);
	
	var _VettrisHeader = __webpack_require__("./src/components/VettrisHeader.js");
	
	var _VettrisHeader2 = _interopRequireDefault(_VettrisHeader);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _utilFunctions = __webpack_require__("./src/utils/util-functions.js");
	
	var _data = __webpack_require__("./contentfuldata/data.json");
	
	var _data2 = _interopRequireDefault(_data);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _MapComponent = __webpack_require__("./src/components/MapComponent.js");
	
	var _MapComponent2 = _interopRequireDefault(_MapComponent);
	
	var _NewsLetter = __webpack_require__("./src/components/NewsLetter.js");
	
	var _NewsLetter2 = _interopRequireDefault(_NewsLetter);
	
	var _VettrisFooter = __webpack_require__("./src/components/VettrisFooter.js");
	
	var _VettrisFooter2 = _interopRequireDefault(_VettrisFooter);
	
	var _ArticleImageWithText = __webpack_require__("./src/components/ArticleImageWithText.js");
	
	var _ArticleImageWithText2 = _interopRequireDefault(_ArticleImageWithText);
	
	var _ArticleHighlight = __webpack_require__("./src/components/ArticleHighlight.js");
	
	var _ArticleHighlight2 = _interopRequireDefault(_ArticleHighlight);
	
	var _marked = __webpack_require__("./node_modules/marked/lib/marked.js");
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactGtmModule = __webpack_require__("./node_modules/react-gtm-module/dist/index.js");
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = exports.IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.changeUrl = function changeUrl(article) {
	    this.props.history.push('/guides/#article=' + article);
	  };
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    var tagManagerArgs = {
	      gtmId: 'GTM-NQXVHS7'
	    };
	    _reactGtmModule2.default.initialize(tagManagerArgs);
	
	    setTimeout(function () {
	      document.body.scrollTop = 0;
	    }, 2);
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var brand = (0, _utilFunctions.getLang)();
	    var items = _data2.default.servicesData[brand].services;
	    var title = _data2.default.singleData[brand].singleData.frontpageItemHeader;
	    var secondTitle = _data2.default.singleData[brand].singleData.frontpageSecondTitle;
	    var paragraph = _data2.default.singleData[brand].singleData.frontpagelongtext;
	    var mapTitle = _data2.default.singleData[brand].singleData.frontpageMapTitle;
	    var mapItems = _data2.default.clinicsData[brand].clinicsData;
	    var heroText = _data2.default.singleData[brand].singleData.frontpageHeroText;
	    var heroImage = _data2.default.singleData[brand].singleData.frontpageHeroImage.fields.file ? _data2.default.singleData[brand].singleData.frontpageHeroImage.fields.file.url : "";
	    var emailText = _data2.default.singleData[brand].singleData.frontpageEmailText;
	    var guides = _data2.default.guideArticlesData[brand].guideArticlesData;
	    var currenNewstTitle = _data2.default.singleData[brand].singleData.frontpageWidgetTitle;
	
	    _marked2.default.setOptions({
	      breaks: true
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_VettrisHeader2.default, { history: this.props.history }),
	      _react2.default.createElement(_Heroimage2.default, { url: heroImage, heroText: heroText }),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-12 hidden-sm hidden-md hidden-lg', style: styles.heroText },
	        _react2.default.createElement('div', { className: 'mobileHeroText', dangerouslySetInnerHTML: { __html: (0, _marked2.default)(heroText) } })
	      ),
	      _react2.default.createElement(
	        _radium.StyleRoot,
	        null,
	        _react2.default.createElement('div', { style: { marginTop: _breakpoints2.default.componentDivider } }),
	        _react2.default.createElement(
	          'div',
	          { style: styles },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-8' },
	            _react2.default.createElement(
	              'h3',
	              { style: { marginTop: 16, fontFamily: 'Merriweather' } },
	              title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              ' ',
	              _react2.default.createElement(_Blueitems2.default, { items: items, history: this.props.history })
	            ),
	            _react2.default.createElement('div', { className: 'clearfix' }),
	            _react2.default.createElement('div', { style: styles.responsiveDivider }),
	            _react2.default.createElement(
	              'h3',
	              { style: { marginTop: _breakpoints2.default.componentDivider, fontFamily: 'Merriweather' } },
	              secondTitle
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              paragraph
	            ),
	            _react2.default.createElement('div', { className: 'clearfix', style: { marginTop: _breakpoints2.default.componentDivider } }),
	            _react2.default.createElement(
	              'div',
	              { className: 'row' },
	              _lodash2.default.sortBy(guides.filter(function (g) {
	                return g.articleHighlight;
	              }), [function (guide) {
	                return guide.articleImage;
	              }]).map(function (guide, a) {
	                if (guide.articleImage) return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.changeUrl((0, _utilFunctions.prettifyUrl)(guide.articleHeadline));
	                    }, className: 'col-xs-12', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    _react2.default.createElement(_ArticleImageWithText2.default, { key: a, twoPanels: true, title: currenNewstTitle, headline: guide.articleHeadline, image: guide.articleImage.fields.file.url })
	                  )
	                );
	                if (guide.articleHighlight) return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.changeUrl((0, _utilFunctions.prettifyUrl)(guide.articleHeadline));
	                    }, className: 'col-xs-12 col-md-6', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    _react2.default.createElement(_ArticleHighlight2.default, { key: a, headline: guide.articleHeadline })
	                  )
	                );
	                return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.changeUrl((0, _utilFunctions.prettifyUrl)(guide.articleHeadline));
	                    }, className: 'col-xs-12 col-md-6', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    guide.articleHeadline
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-4 col-xs-12', style: styles.firstRow },
	            _react2.default.createElement(
	              'div',
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(_MapComponent2.default, { items: mapItems, title: mapTitle, history: this.props.history })
	            )
	          ),
	          _react2.default.createElement('div', { className: 'clearfix' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_NewsLetter2.default, { text: emailText })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { style: { marginTop: _breakpoints2.default.componentDivider } })
	        )
	      ),
	      _react2.default.createElement(_VettrisFooter2.default, null)
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(IndexPage);
	
	
	var styles = (_styles = {
	  width: '100%',
	  margin: '0 auto'
	}, _styles[_breakpoints2.default.media.siteOverMaxWidth] = {
	  width: _breakpoints2.default.width.site
	}, _styles.firstRow = {
	  marginTop: _breakpoints2.default.componentDivider
	}, _styles.divider = {
	  marginTop: 20
	}, _styles.singleArticleLink = {
	  textDecoration: 'none',
	  color: _colors2.default.darkBlue,
	  ':hover': {
	    cursor: 'pointer'
	  }
	}, _styles.dividerSingleItem = (_dividerSingleItem = {
	  paddingBottom: 30
	}, _dividerSingleItem[_breakpoints2.default.media.siteUnderMaxWidth] = {
	  marginTop: 0,
	  paddingTop: 0,
	  paddingBottom: 20
	}, _dividerSingleItem), _styles.responsiveDivider = (_responsiveDivider = {
	  marginTop: _breakpoints2.default.componentDivider
	}, _responsiveDivider[_breakpoints2.default.media.siteUnderPadWidth] = {
	  marginTop: _breakpoints2.default.mobileDivider
	}, _responsiveDivider), _styles.heroText = {
	  marginTop: 20,
	  marginBottom: 40
	}, _styles);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-831f243514d0f732b299.js